import { GuidesAdminTile } from "@/pages/AdminCreators";

/**
 * Admin guides page. Reuses the GuidesAdminTile component, which handles
 * create, edit, publish and unpublish, and for creator guides the ranked
 * lookup and exclusions.
 */
export default function AdminGuides() {
    return (
        <section data-testid="admin-guides-wrapper">
            <header className="mb-5">
                <h1 className="font-display text-3xl font-bold tracking-tight">
                    Guides
                </h1>
                <p className="text-sm text-black/60 mt-1">
                    Creator and topic guides. Each creator guide is the
                    ranked list for its city and niche: the guide page shows
                    the top 10 and each listed creator's page compares them
                    with the top 4 others.
                </p>
            </header>
            <GuidesAdminTile openByDefault />
        </section>
    );
}
